import React, { useContext, useEffect, useState } from "react";

const UserContext = React.createContext();
export const UserProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [send, setSend] = useState(false);
  const [open, setOpen] = useState(false);
  const [captchaState, setCaptchaState] = useState({
    ask: false,
    token: "",
  });

  function openModal() {
    setModalIsOpen(true);
  }

  function closeModal() {
    setModalIsOpen(false);
  }

  function openNav() {
    if (open) {
      document.getElementById("mySidenav").style.width = "0";
      setOpen(!open);
    } else {
      if (window.screen.width < 501) {
        var k = parseInt(window.screen.width);
        document.getElementById("mySidenav").style.width = k + "px";
      } else {
        document.getElementById("mySidenav").style.width = "250px";
      }
      setOpen(!open);
    }
  }

  const getUserState = () => {
    let stateOfUser = JSON.parse(localStorage.getItem("userState"));
    //console.log("get UserState()", stateOfUser);
    if (stateOfUser) {
      // console.log("getUserState true", stateOfUser);
      return JSON.parse(localStorage.getItem("userState"));
    } else {
      // console.log("getUserState else");
      const stateOfUser = {
        token: "string",
        id: 0,
        success: true,
        message: "string",
        code: 0,
        user: {
          id: 0,
          userName: "string",
          name: "string",
          lastName: "string",
          personalId: "string",
          registrationAddress: "string",
          userTypeId: 0,
          userTypeName: "string",
          mobile: "string",
          email: "string",
        },
        amountPayed: 0,
        amountByInvoices: 0,
        amountBalance: 0,
        amountTotalPent: 0,
        amountUnPayedInvoices: 0,
        countDeliveryOrders: 0,
      };
      return stateOfUser;
    }
  };

  function clearUserState() {
    //localStorage.removeItem("userState");
    setUserState(getUserState());
  }

  const [userState, setUserState] = useState(getUserState());

  //console.log("context userState", userState);

  useEffect(() => {
    //localStorage.setItem("userState", JSON.stringify(userState));
    // console.log("context effect", userState);
  }, [userState]);

  return (
    <UserContext.Provider
      value={{
        userState,
        setUserState,
        modalIsOpen,
        setModalIsOpen,
        openModal,
        closeModal,
        captchaState,
        setCaptchaState,
        clearUserState,
        send,
        setSend,
        openNav,
        open,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => {
  return useContext(UserContext);
};
